import { Component, Vue, Prop } from 'vue-property-decorator';
import { sendInBlueFooter } from './Footer.services'

@Component
export default class Footer extends Vue{
    constructor(){
        super();
    }
    mounted(): void{

    }
    public email_sub = '';
    public message = '';

    SubscribeClick(){
        const form: any = document.getElementById('sub_form');
        console.log("FormData - "+this.email_sub);
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var Flag =  regex.test(this.email_sub);
        console.log("Flag value - "+ Flag)
        if (this.email_sub === "" || !Flag){
            this.$bvToast.toast('Please enter a valid Email ID.',{
                title:'Error',
                variant:'danger'
            });
        }else{
            let postData = {
                "data":{
                    "email":this.email_sub
                }
            }
            sendInBlueFooter.SendInBlueAuth(postData).then((response: any) => {
                console.log(response.data.message)
                this.message = response.data.message;
                this.$bvToast.toast(this.message,{
                    title:'Thank You',
                    variant:'sucess'
                });
            }).catch((error:any) => {
                console.log(error)
                this.$bvToast.toast('Your email ID is not authenticated successfully.',{
                    title:'Error',
                    variant:'danger'
                });
            })
        }
        const formData = new FormData(form);

    }
}